import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { SorderLine } from './s-order-line';
import { SalesTransactionPromoDetail } from './sales-transaction-promo-detail';
import { SorderDelivery } from './sorder-delivery';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';


export class Sorder extends BaseEntity {
  
  sorderCode      : string;
  partner         : Partner;
  periodActiveDay : Date;
  discount        : number;
  amount          : number;
  canceled        : boolean;
  closed          : boolean;
  theDate         : Date;
  person          : Person;
  role            : Role

  
  sorderLines                   : SorderLine[] = [];
  salesTransactionPromoDetails  : SalesTransactionPromoDetail[] = [];
  sorderDeliveries              : SorderDelivery[] ;


  constructor() {
    super()
  }
 
}
 


